<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="SettingsOverview")
    h1.title Channelmanager
    .sub-headline Hier können Sie alle Channel verwalten.

    .rent-object-features-wrapper.margin-top
      b-tabs(vertical)
        b-tab-item(v-for="channel in channels" icon="weather-sunny" :label="channel.name")
          .form.w400
            .card
              .top
                h2.title.is-6 Authentifizierung
                template(v-for="auth in Object.entries(channel.authData)")
                  b-field(
                  :label="auth[1].label",
                  label-position="on-border"
                  )
                    b-input(:type="auth[1].type" :value="auth[1].value")
              
              //- .top
                ChannelConfigEditor(:configTemplate="channel.configTemplate")
              //- .main.padding
                .button-wrapper.right
                  b-button(type="is-primary" disabled) Speichern

</template>

<script>
import ChannelConfigEditor from '@/components/atoms/ChannelConfigEditor.vue';

export default {
  components: {
    ChannelConfigEditor
  },
  data() {
    return {
      channels: []
    };
  },
  methods: {
  },
  async mounted() {
    this.channels = await this.$store.dispatch("channels/findAll");
  },
};
</script>

<style lang="scss" scoped>

</style>